import Box, { BoxProps } from '@mui/material/Box';

function ContainerFluid(props: BoxProps) {
  return <Box width="100%" marginX="auto" padding="10px 20px" {...props} />;
}

export default ContainerFluid;
